import React, {useContext, useEffect, useState} from "react";
import Header from "../../../components/header/header";
import SettingsSubmenu from "../components/submenu/settings_submenu";
import SettingsSection from "../components/section/section";
import styles from '../styles/settings.module.css';
import axiosInstance from "../../../AxiosInstance";
import Modal from "../../../components/modal/modal";
import {LogoInput, SelectInput, TextInput} from "../../../components/input/inputs";
import {useTranslation} from "react-i18next";
import MyContext from "../../../Context";
import i18n from "../../../i18n";

const LANGUAGE_OPTIONS = [
    {id: 'en', name: 'English'},
    {id: 'es', name: 'Español'},
    {id: 'fr', name: 'Français'},
];

const TIMEZONE_OPTIONS = [
    // UTC
    {id: 'UTC', name: 'UTC (Coordinated Universal Time)'},

    // Americas - North
    {id: 'US/Eastern', name: 'US/Eastern (New York) UTC-5'},
    {id: 'US/Central', name: 'US/Central (Chicago) UTC-6'},
    {id: 'US/Mountain', name: 'US/Mountain (Denver) UTC-7'},
    {id: 'US/Pacific', name: 'US/Pacific (Los Angeles) UTC-8'},
    {id: 'America/Anchorage', name: 'America/Anchorage (Alaska) UTC-9'},
    {id: 'Pacific/Honolulu', name: 'Pacific/Honolulu (Hawaii) UTC-10'},
    {id: 'America/Toronto', name: 'America/Toronto (Canada East) UTC-5'},

    // Americas - Mexico & Central America
    {id: 'America/Mexico_City', name: 'America/Mexico_City UTC-6'},
    {id: 'America/Cancun', name: 'America/Cancun (Mexico SE) UTC-5'},
    {id: 'America/Tijuana', name: 'America/Tijuana (Mexico NW) UTC-8'},
    {id: 'America/Guatemala', name: 'America/Guatemala UTC-6'},
    {id: 'America/Costa_Rica', name: 'America/Costa_Rica UTC-6'},
    {id: 'America/Panama', name: 'America/Panama UTC-5'},
    {id: 'America/El_Salvador', name: 'America/El_Salvador UTC-6'},
    {id: 'America/Tegucigalpa', name: 'America/Tegucigalpa (Honduras) UTC-6'},
    {id: 'America/Managua', name: 'America/Managua (Nicaragua) UTC-6'},
    {id: 'America/Belize', name: 'America/Belize UTC-6'},

    // Americas - Caribbean
    {id: 'America/Havana', name: 'America/Havana (Cuba) UTC-5'},
    {id: 'America/Santo_Domingo', name: 'America/Santo_Domingo (Dom. Rep.) UTC-4'},
    {id: 'America/Jamaica', name: 'America/Jamaica UTC-5'},
    {id: 'America/Puerto_Rico', name: 'America/Puerto_Rico UTC-4'},
    {id: 'America/Port-au-Prince', name: 'America/Port-au-Prince (Haiti) UTC-5'},

    // Americas - South America
    {id: 'America/Bogota', name: 'America/Bogota (Colombia) UTC-5'},
    {id: 'America/Lima', name: 'America/Lima (Peru) UTC-5'},
    {id: 'America/Guayaquil', name: 'America/Guayaquil (Ecuador) UTC-5'},
    {id: 'America/Caracas', name: 'America/Caracas (Venezuela) UTC-4'},
    {id: 'America/La_Paz', name: 'America/La_Paz (Bolivia) UTC-4'},
    {id: 'America/Santiago', name: 'America/Santiago (Chile) UTC-4'},
    {id: 'America/Argentina/Buenos_Aires', name: 'America/Buenos_Aires (Argentina) UTC-3'},
    {id: 'America/Montevideo', name: 'America/Montevideo (Uruguay) UTC-3'},
    {id: 'America/Asuncion', name: 'America/Asuncion (Paraguay) UTC-4'},
    {id: 'America/Sao_Paulo', name: 'America/Sao_Paulo (Brazil) UTC-3'},
    {id: 'America/Manaus', name: 'America/Manaus (Brazil West) UTC-4'},
    {id: 'America/Paramaribo', name: 'America/Paramaribo (Suriname) UTC-3'},
    {id: 'America/Guyana', name: 'America/Guyana UTC-4'},

    // Europe - Western
    {id: 'Europe/London', name: 'Europe/London (UK) UTC+0'},
    {id: 'Europe/Dublin', name: 'Europe/Dublin (Ireland) UTC+0'},
    {id: 'Europe/Lisbon', name: 'Europe/Lisbon (Portugal) UTC+0'},

    // Europe - Central
    {id: 'Europe/Madrid', name: 'Europe/Madrid (Spain) UTC+1'},
    {id: 'Europe/Paris', name: 'Europe/Paris (France) UTC+1'},
    {id: 'Europe/Berlin', name: 'Europe/Berlin (Germany) UTC+1'},
    {id: 'Europe/Rome', name: 'Europe/Rome (Italy) UTC+1'},
    {id: 'Europe/Amsterdam', name: 'Europe/Amsterdam (Netherlands) UTC+1'},
    {id: 'Europe/Brussels', name: 'Europe/Brussels (Belgium) UTC+1'},
    {id: 'Europe/Zurich', name: 'Europe/Zurich (Switzerland) UTC+1'},
    {id: 'Europe/Vienna', name: 'Europe/Vienna (Austria) UTC+1'},
    {id: 'Europe/Warsaw', name: 'Europe/Warsaw (Poland) UTC+1'},
    {id: 'Europe/Prague', name: 'Europe/Prague (Czech Rep.) UTC+1'},
    {id: 'Europe/Stockholm', name: 'Europe/Stockholm (Sweden) UTC+1'},
    {id: 'Europe/Oslo', name: 'Europe/Oslo (Norway) UTC+1'},
    {id: 'Europe/Copenhagen', name: 'Europe/Copenhagen (Denmark) UTC+1'},

    // Europe - Eastern
    {id: 'Europe/Athens', name: 'Europe/Athens (Greece) UTC+2'},
    {id: 'Europe/Bucharest', name: 'Europe/Bucharest (Romania) UTC+2'},
    {id: 'Europe/Helsinki', name: 'Europe/Helsinki (Finland) UTC+2'},
    {id: 'Europe/Istanbul', name: 'Europe/Istanbul (Turkey) UTC+3'},
    {id: 'Europe/Moscow', name: 'Europe/Moscow (Russia) UTC+3'},
    {id: 'Europe/Kiev', name: 'Europe/Kiev (Ukraine) UTC+2'},

    // Africa
    {id: 'Africa/Casablanca', name: 'Africa/Casablanca (Morocco) UTC+1'},
    {id: 'Africa/Algiers', name: 'Africa/Algiers (Algeria) UTC+1'},
    {id: 'Africa/Tunis', name: 'Africa/Tunis (Tunisia) UTC+1'},
    {id: 'Africa/Cairo', name: 'Africa/Cairo (Egypt) UTC+2'},
    {id: 'Africa/Lagos', name: 'Africa/Lagos (Nigeria) UTC+1'},
    {id: 'Africa/Accra', name: 'Africa/Accra (Ghana) UTC+0'},
    {id: 'Africa/Dakar', name: 'Africa/Dakar (Senegal) UTC+0'},
    {id: 'Africa/Abidjan', name: 'Africa/Abidjan (Ivory Coast) UTC+0'},
    {id: 'Africa/Nairobi', name: 'Africa/Nairobi (Kenya) UTC+3'},
    {id: 'Africa/Dar_es_Salaam', name: 'Africa/Dar_es_Salaam (Tanzania) UTC+3'},
    {id: 'Africa/Addis_Ababa', name: 'Africa/Addis_Ababa (Ethiopia) UTC+3'},
    {id: 'Africa/Kampala', name: 'Africa/Kampala (Uganda) UTC+3'},
    {id: 'Africa/Kigali', name: 'Africa/Kigali (Rwanda) UTC+2'},
    {id: 'Africa/Johannesburg', name: 'Africa/Johannesburg (South Africa) UTC+2'},
    {id: 'Africa/Maputo', name: 'Africa/Maputo (Mozambique) UTC+2'},
    {id: 'Africa/Lusaka', name: 'Africa/Lusaka (Zambia) UTC+2'},
    {id: 'Africa/Harare', name: 'Africa/Harare (Zimbabwe) UTC+2'},
    {id: 'Africa/Kinshasa', name: 'Africa/Kinshasa (DR Congo West) UTC+1'},
    {id: 'Africa/Lubumbashi', name: 'Africa/Lubumbashi (DR Congo East) UTC+2'},
    {id: 'Africa/Douala', name: 'Africa/Douala (Cameroon) UTC+1'},
    {id: 'Africa/Libreville', name: 'Africa/Libreville (Gabon) UTC+1'},

    // Middle East / Gulf
    {id: 'Asia/Dubai', name: 'Asia/Dubai (UAE) UTC+4'},
    {id: 'Asia/Riyadh', name: 'Asia/Riyadh (Saudi Arabia) UTC+3'},
    {id: 'Asia/Qatar', name: 'Asia/Qatar (Doha) UTC+3'},
    {id: 'Asia/Kuwait', name: 'Asia/Kuwait UTC+3'},
    {id: 'Asia/Bahrain', name: 'Asia/Bahrain UTC+3'},
    {id: 'Asia/Muscat', name: 'Asia/Muscat (Oman) UTC+4'},
    {id: 'Asia/Baghdad', name: 'Asia/Baghdad (Iraq) UTC+3'},
    {id: 'Asia/Tehran', name: 'Asia/Tehran (Iran) UTC+3:30'},
    {id: 'Asia/Jerusalem', name: 'Asia/Jerusalem (Israel) UTC+2'},
    {id: 'Asia/Amman', name: 'Asia/Amman (Jordan) UTC+3'},
    {id: 'Asia/Beirut', name: 'Asia/Beirut (Lebanon) UTC+2'},

    // Asia
    {id: 'Asia/Kolkata', name: 'Asia/Kolkata (India) UTC+5:30'},
    {id: 'Asia/Karachi', name: 'Asia/Karachi (Pakistan) UTC+5'},
    {id: 'Asia/Dhaka', name: 'Asia/Dhaka (Bangladesh) UTC+6'},
    {id: 'Asia/Bangkok', name: 'Asia/Bangkok (Thailand) UTC+7'},
    {id: 'Asia/Jakarta', name: 'Asia/Jakarta (Indonesia) UTC+7'},
    {id: 'Asia/Singapore', name: 'Asia/Singapore UTC+8'},
    {id: 'Asia/Kuala_Lumpur', name: 'Asia/Kuala_Lumpur (Malaysia) UTC+8'},
    {id: 'Asia/Manila', name: 'Asia/Manila (Philippines) UTC+8'},
    {id: 'Asia/Shanghai', name: 'Asia/Shanghai (China) UTC+8'},
    {id: 'Asia/Hong_Kong', name: 'Asia/Hong_Kong UTC+8'},
    {id: 'Asia/Seoul', name: 'Asia/Seoul (South Korea) UTC+9'},
    {id: 'Asia/Tokyo', name: 'Asia/Tokyo (Japan) UTC+9'},

    // Oceania
    {id: 'Australia/Sydney', name: 'Australia/Sydney UTC+10'},
    {id: 'Australia/Melbourne', name: 'Australia/Melbourne UTC+10'},
    {id: 'Australia/Perth', name: 'Australia/Perth UTC+8'},
    {id: 'Pacific/Auckland', name: 'Pacific/Auckland (New Zealand) UTC+12'},
];

export default function GeneralSettings() {
    const {t} = useTranslation();
    const {user} = useContext(MyContext);
    const isAdmin = user?.is_superuser || user?.role?.name === 'Super Admin';
    const [showModal, setShowModal] = useState(false);
    const [form, setForm] = useState({});
    const [company, setCompany] = useState({});
    const [langForm, setLangForm] = useState({language: 'en'});

    useEffect(() => {
        axiosInstance.get(`corporate_group/get_current/`).then((res) => {
            setCompany(res.data);
            setForm(res.data)
        });
    }, []);

    useEffect(() => {
        if (user?.language) {
            setLangForm({language: user.language});
        }
    }, [user]);

    const updateCG = () => {
        let formData = new FormData();
        const adminOnlyFields = ['name', 'timezone'];
        for(const key in form) {
            if (!isAdmin && adminOnlyFields.includes(key)) continue;
            const val = form[key];
            if (val === null || val === undefined || typeof val === 'object') continue;
            formData.append(key, val);
        }

        // Append logo file if selected
        if (form.logo instanceof File) {
            formData.append('logo', form.logo);
        }

        const companySave = axiosInstance.put(`corporate_group/${company.id}/`, formData);

        const langFormData = new FormData();
        langFormData.append('language', langForm.language);
        const langSave = axiosInstance.post('change_pp/', langFormData);

        Promise.all([companySave, langSave]).then(() => {
            if (langForm.language !== i18n.language) {
                localStorage.setItem('user_language', langForm.language);
                i18n.changeLanguage(langForm.language);
            }
            window.location.reload();
        });
    }

    const getTimezoneDisplay = (tzId) => {
        const found = TIMEZONE_OPTIONS.find(tz => tz.id === tzId);
        return found ? found.name : (tzId || 'UTC');
    };

    return (
        <div className={styles.dashboard_container}>
            <Header/>

            <Modal show={showModal} setter={setShowModal} name={t('settings.general.editInfo')} buttonName={t('common.save')} onClick={updateCG}>
                <LogoInput form={form} setForm={setForm} name={'logo'} current={company.image?.image}/>
                {isAdmin ? (
                    <TextInput form={form} setForm={setForm} name={'name'}/>
                ) : (
                    <div style={{marginBottom: '12px'}}>
                        <label style={{fontSize: '13px', color: '#64748B', display: 'block', marginBottom: '4px'}}>{t('settings.general.name')}</label>
                        <div style={{padding: '8px', background: '#F8FAFC', border: '1px solid #E2E8F0', borderRadius: '6px', fontSize: '13px', color: '#334155'}}>{form.name}</div>
                    </div>
                )}
                {isAdmin ? (
                    <SelectInput
                        name={t('settings.general.timezone')}
                        internalName={'timezone'}
                        form={form}
                        setForm={setForm}
                        options={TIMEZONE_OPTIONS}
                    />
                ) : (
                    <div style={{marginBottom: '12px'}}>
                        <label style={{fontSize: '13px', color: '#64748B', display: 'block', marginBottom: '4px'}}>{t('settings.general.timezone')}</label>
                        <div style={{padding: '8px', background: '#F8FAFC', border: '1px solid #E2E8F0', borderRadius: '6px', fontSize: '13px', color: '#334155'}}>{getTimezoneDisplay(form.timezone)}</div>
                    </div>
                )}
                <SelectInput
                    name={t('settings.general.language')}
                    internalName={'language'}
                    form={langForm}
                    setForm={setLangForm}
                    options={LANGUAGE_OPTIONS}
                />

                <div style={{marginTop: '20px', paddingTop: '16px', borderTop: '1px solid #E2E8F0'}}>
                    <div style={{fontSize: '14px', fontWeight: '600', color: '#334155', marginBottom: '12px'}}>{t('settings.general.gpsMapSettings')}</div>
                    <div style={{marginBottom: '10px'}}>
                        <label style={{fontSize: '13px', color: '#64748B', display: 'block', marginBottom: '4px'}}>{t('settings.general.mapZoom')}</label>
                        <input
                            type="number" min="1" max="20"
                            value={form.gps_map_zoom || 15}
                            onChange={e => setForm({...form, gps_map_zoom: Math.min(20, Math.max(1, parseInt(e.target.value) || 1))})}
                            style={{width: '100%', padding: '8px', borderRadius: '6px', border: '1px solid #CBD5E1', fontSize: '13px'}}
                        />
                    </div>
                    <div style={{marginBottom: '10px'}}>
                        <label style={{fontSize: '13px', color: '#64748B', display: 'block', marginBottom: '4px'}}>{t('settings.general.centerLat')}</label>
                        <input
                            type="number" step="0.0001"
                            value={form.gps_map_center_lat ?? 14.72}
                            onChange={e => setForm({...form, gps_map_center_lat: e.target.value})}
                            style={{width: '100%', padding: '8px', borderRadius: '6px', border: '1px solid #CBD5E1', fontSize: '13px'}}
                        />
                    </div>
                    <div>
                        <label style={{fontSize: '13px', color: '#64748B', display: 'block', marginBottom: '4px'}}>{t('settings.general.centerLng')}</label>
                        <input
                            type="number" step="0.0001"
                            value={form.gps_map_center_lng ?? -75.12}
                            onChange={e => setForm({...form, gps_map_center_lng: e.target.value})}
                            style={{width: '100%', padding: '8px', borderRadius: '6px', border: '1px solid #CBD5E1', fontSize: '13px'}}
                        />
                    </div>
                </div>
            </Modal>

            <div className={styles.dashboardInnerContainer}>
                <SettingsSubmenu active={0}/>

                <SettingsSection title={t('settings.general.title')} description={t('settings.general.description')}>
                    <div side={'left'}>
                        <div className={styles.lightButton} onClick={() => setShowModal(true)}>{t('settings.general.editInfo')}</div>
                    </div>
                    <div side={'right'} className={'d-flex'}>
                        <div className={`${styles.squareContainer} p-3`}>
                            <div className={'d-flex flex-row align-items-center mb-3'}>
                                <img src={company.image ? company.image.image : '/mid_cloud.png'} height={'80px'} alt={'icon'}/>
                                <div className={`${styles.clickableText} ps-3`} onClick={() => setShowModal(true)}>{t('settings.general.changeLogo')}</div>
                            </div>
                            <div className={styles.title}>{t('settings.general.generalInfo')}</div>

                            <div className={`d-flex flex-wrap ${styles.infoLines}`}>
                                <div style={{flexBasis: "25%"}}>{t('settings.general.name')}</div>
                                <div style={{flexBasis: "75%"}}>{company.name}</div>

                                <div style={{flexBasis: "25%"}}>{t('settings.general.timezone')}</div>
                                <div style={{flexBasis: "75%"}}>{getTimezoneDisplay(company.timezone)}</div>

                                <div style={{flexBasis: "25%"}}>{t('settings.general.language')}</div>
                                <div style={{flexBasis: "75%"}}>{LANGUAGE_OPTIONS.find(l => l.id === user?.language)?.name || user?.language}</div>

                                <div style={{flexBasis: "25%"}}>{t('settings.general.workspaceId')}</div>
                                <div style={{flexBasis: "75%"}}>{company.id}</div>
                            </div>

                            <div className={styles.title} style={{marginTop: '16px'}}>{t('settings.general.gpsMapSettings')}</div>
                            <div className={`d-flex flex-wrap ${styles.infoLines}`}>
                                <div style={{flexBasis: "25%"}}>{t('settings.general.mapZoom')}</div>
                                <div style={{flexBasis: "75%"}}>{company.gps_map_zoom || 15}</div>

                                <div style={{flexBasis: "25%"}}>{t('settings.general.centerLat')}</div>
                                <div style={{flexBasis: "75%"}}>{company.gps_map_center_lat ?? 14.72}</div>

                                <div style={{flexBasis: "25%"}}>{t('settings.general.centerLng')}</div>
                                <div style={{flexBasis: "75%"}}>{company.gps_map_center_lng ?? -75.12}</div>
                            </div>
                        </div>
                    </div>
                </SettingsSection>
            </div>
        </div>
    );
}